<template>
  <div class="cards__container">
    <div class="cards__single gray">
      <p class="cards__title">
        Registration
      </p>
      <div class="cards__description">
        <p>8:00 AM - 4:00 PM</p>
      </div>
      <div class="cards__location">
        @ Patio del Fauno Lobby
      </div>
    </div>
    <div class="cards__single grayblue">
      <p class="cards__title">
        Breakfast
      </p>
      <div class="cards__description">
        <p>8:00 AM - 10:00 AM</p>
      </div>
      <div class="cards__location">
        @ Patio del Fauno Lobby
      </div>
    </div>
    <div v-for="(speaker, index) in speakers" :key="index" class="cards__single cerulean" :class="speaker.class">
      <div v-if="speaker.imgClass" :class="'speaker-img ' + speaker.imgClass"></div>
      <div v-if="speaker.imgClass" class="circle"></div>
      <div class="cards__speaker">
        <p class="cards__name">{{ speaker.name }}</p>
        <p class="cards__spktitle spkposition" v-html="speaker.position"></p>
        <p class="cards__spktitle" v-html="speaker.title"></p>
      </div>
      <div class="cards__description">
        <p class="time">{{ speaker.time }}</p>
        <p class="location">{{ speaker.location }}</p>
      </div>
    </div>
    <div class="cards__single purple noheight">
      <p class="cards__title">
        1:1 Meetings
      </p>
      <div class="cards__description">
        <p>10:00 AM - 4:00 PM</p>
      </div>
      <div class="cards__location">
        @ Salon Dorado
      </div>
    </div>
  </div>
  <div class="morning">
    <h2 class="subtitle">
      Morning Sessions
    </h2>
    <div v-if="isMobile" class="mobile slider">
      <carousel>
        <slide :key="1">
          <div class="grid__tracks">
            <div class="--title">
              Track 1 (Fauno West)
            </div>
            <div class="--slot t1" v-for="info in track1" :key="info.company" @click="openModal(info.company)">
              <div class="--slot__time">
                <p>{{ info.start }}</p>
                <p>{{ info.end }}</p>
              </div>
              <p class="--slot__title">
                {{ info.company }}
              </p>
            </div>
          </div>
        </slide>
        <slide :key="2">
          <div class="grid__tracks">
            <div class="--title">
              Track 2 (Patio del Fauno)
            </div>
            <div class="--slot t2" v-for="info in track2" :key="info.company" @click="openModal(info.company)">
              <div class="--slot__time">
                <p>{{ info.start }}</p>
                <p>{{ info.end }}</p>
              </div>
              <p class="--slot__title">
                {{ info.company }}
              </p>
            </div>
          </div>
        </slide>
        <slide :key="3">
          <div class="grid__tracks">
            <div class="--title">
              Track 3 (Fauno East)
            </div>
            <div class="--slot t3" v-for="info in track3" :key="info.company" @click="openModal(info.company)">
              <div class="--slot__time">
                <p>{{ info.start }}</p>
                <p>{{ info.end }}</p>
              </div>
              <p class="--slot__title">
                {{ info.company }}
              </p>
            </div>
          </div>
        </slide>
        <template #addons>
          <navigation />
        </template>
      </carousel>
    </div>
    <div v-else>
      <div class="grid__container">
        <div class="grid__tracks">
          <div class="--title">
            Track 1 (Fauno West)
          </div>
          <div class="--slot t1 clickable" v-for="info in track1" :key="info.company" @click="openModal(info.company)">
            <div class="--slot__time">
              <p>{{ info.start }}</p>
              <p>{{ info.end }}</p>
            </div>
            <p class="--slot__title">
              {{ info.company }}
            </p>
          </div>
        </div>
        <div class="grid__tracks">
          <div class="--title">
            Track 2 (Patio del Fauno)
          </div>
          <div class="--slot t2 clickable" v-for="info in track2" :key="info.company" @click="openModal(info.company)">
            <div class="--slot__time">
              <p>{{ info.start }}</p>
              <p>{{ info.end }}</p>
            </div>
            <p class="--slot__title">
              {{ info.company }}
            </p>
          </div>
        </div>
        <div class="grid__tracks">
          <div class="--title">
            Track 3 (Fauno East)
          </div>
          <div class="--slot t3 clickable" v-for="info in track3" :key="info.company" @click="openModal(info.company)">
            <div class="--slot__time">
              <p>{{ info.start }}</p>
              <p>{{ info.end }}</p>
            </div>
            <p class="--slot__title">
              {{ info.company }}
            </p>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div :class="{ 'modal-show': isModalOpen }" v-if="isModalOpen" class="modal" @click="handleModalBackdropClick">
    <div class="modal-content" @click.stop>
      <span class="close" @click="closeModal">&times;</span>
      <div v-if="errorMessage">
        <h1 class="title">Error</h1>
        <p class="description">{{ errorMessage }}</p>
      </div>
      <div v-else>
        <h1 class="speaker">{{ activeCardInfo?.speaker || activeCompanyInfo?.company }}</h1>
        <h2 v-if="activeCardInfo" class="title">{{ activeCardInfo.title }}</h2>
        <p class="description" v-if="activeCardInfo" v-html="activeCardInfo.description"></p>
        <p class="description" v-if="activeCompanyInfo">{{ activeCompanyInfo.description }}</p>
        <a
          v-if="activeCompanyInfo?.url"
          :href="activeCompanyInfo.url"
          target="_blank"
          class="btn-new-alt"
        >
          Visit Website
          <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
            <path d="M5 12h14M12 5l7 7-7 7"/>
          </svg>
        </a>
      </div>
    </div>
  </div>
</template>

<script>
import 'vue3-carousel/dist/carousel.css'
import { Carousel, Slide, Navigation } from 'vue3-carousel'

export default {
  name: 'Day Two Morning',
  components: {
    Carousel,
    Slide,
    Navigation,
  },
  data() {
    return {
      track1: [
        { start: '10:00 AM', end: '10:30 AM', company: 'Newton Golf Company', hr: '10:00', duration: 29 },
        { start: '10:30 AM', end: '11:00 AM', company: 'Oragenics, Inc.', hr: '10:30', duration: 29 },
        { start: '11:00 AM', end: '11:30 AM', company: 'Adaptin Bio, Inc.', hr: '11:00', duration: 29 },
        { start: '11:30 AM', end: '12:00 PM', company: 'The Society Pass', hr: '11:30', duration: 29 }
      ],
      track2: [
        { start: '10:00 AM', end: '10:20 AM', company: 'Fireside Chat: Chardan', hr: '10:00', duration: 29 },
        { start: '10:30 AM', end: '11:00 AM', company: 'Stewards, Inc.', hr: '10:30', duration: 29 },
        { start: '11:00 AM', end: '11:30 AM', company: 'Greg Nickolson - dTAO', hr: '11:00', duration: 29 },
        { start: '11:30 AM', end: '12:00 PM', company: 'Realbricks', hr: '11:30', duration: 29 }
      ],
      track3: [
        { start: '10:00 AM', end: '10:30 AM', company: 'MindWalk', hr: '10:00', duration: 29 },
        { start: '10:30 AM', end: '11:00 AM', company: 'Metavesco', hr: '10:30', duration: 29 },
        { start: '11:00 AM', end: '11:30 AM', company: "Charlie's Holdings, Inc.", hr: '11:00', duration: 29 },
        { start: '11:30 AM', end: '12:00 PM', company: 'FullPac', hr: '11:30', duration: 29 }
      ],
      companyData: {
        'TRX Gold': {
          description: 'TRX Gold Corporation (NYSE American & TSX: TRX) is a Canadian gold mining and exploration company advancing its flagship Buckreef Gold Project, a high-margin, open-pit operation in Tanzania with established processing infrastructure and expansion potential aimed at increasing annual gold production and growing mineral resources.',
          url: 'https://trxgold.com/',
        },
        'Oragenics, Inc.': {
          description: 'Oragenics, Inc. (NYSE American: OGEN) is a biotechnology company developing proprietary intranasal delivery technologies aimed at revolutionizing treatment options for neurological trauma and CNS disorders, with lead programs targeting conditions such as concussion and other brain-related injuries.',
          url: 'https://www.oragenics.com/'
        },
        'Aclarion, Inc.': {
          description: 'Aclarion, Inc. (NASDAQ: ACON) is a healthcare technology company leveraging advanced magnetic resonance spectroscopy and proprietary biomarker analytics to provide diagnostic tools such as the NOCISCAN suite that help physicians more precisely identify and treat sources of pain in spinal disorders.',
          url: 'https://aclarion.com/'
        },
        'The Society Pass': {
          description: 'Society Pass Incorporated (SOPA) is a Singapore-based, acquisition-focused tech holding company building an e-commerce and loyalty ecosystem in Southeast Asia, operating in digital media, lifestyle (fashion/beauty), food delivery, travel, and telecoms, aiming to create personalized customer experiences through data and universal loyalty points. Founded in 2018, it went public on Nasdaq in 2021, acquiring companies like Leflair, Handycart, and Thoughtful Media Group to link merchants and consumers across verticals. ',
          url: 'https://www.thesocietypass.com/'
        },
        'Fireside Chat: Chardan': {
          description: 'Chardan is an independent, full-service, global investment bank focused on supporting the capital markets goals of corporate and institutional clients. Chardan has broad deal experience, having participated in more than 700 transactions with an aggregate transaction value of over $120 billion. Headquartered in New York City, Chardan is a registered broker-dealer with the U.S.  Securities and Exchange Commission and is a member of the following: FINRA, SIPC, and NASDAQ.',
          url: 'https://www.chardan.com/'
        },
        'Stewards, Inc.': {
          description: 'Stewards, Inc. is a U.S. nonprofit organization focused on serving vulnerable populations—particularly individuals with disabilities, the elderly, and those with mental health challenges—by providing representative payee services, budgeting support, and connections to community resources to help clients maintain financial stability and access essential services.',
          url: 'https://stewards.com/'
        },
        'Auddia Inc.': {
          description: 'Auddia Inc. (NASDAQ: AUUD / AUUDW) is a technology and AI audio company developing proprietary platforms like the faidr audio app to transform how listeners engage with AM/FM radio, podcasts, and digital audio content, while pursuing strategic restructuring and business combination opportunities to accelerate growth.',
          url: 'https://www.auddia.com/'
        },
        'Adaptin Bio, Inc.': {
          description: 'Adaptin Bio, Inc. is a biotechnology company developing novel therapies for oncology and central nervous system disorders with improved drug delivery to the brain and other tissues. The company’s proprietary Brain Bispecific T cell Engager (BRiTE) technology was developed by researchers at the Department of Neurosurgery at Duke University. The company’s mission is to develop novel therapies to improve patient outcomes in difficult-to-treat cancers. For more information, visit www.adaptinbio.com.',
          url: 'https://adaptinbio.com/'
        },
        'MindWalk': {
          description: 'MindWalk (NASDAQ: HYFT) is a Bio-Native AI biotechnology company that integrates artificial intelligence, multi-omics data, and advanced laboratory research through its proprietary LensAI™ platform to make complex biological systems computable and accelerate the discovery and development of biologics such as therapeutic antibodies, vaccines, and peptide drugs. Originally founded as ImmunoPrecise Antibodies, the Austin, Texas-based firm rebranded as MindWalk and shifted from traditional wet-lab services toward a scalable intelligence-platform model that offers data-driven solutions, SaaS offerings, and collaborative research to reshape drug discovery workflows and unlock new therapeutic possibilities.',
          url: 'https://www.mindwalkai.com/'
        },
        'Metavesco': {
          description: 'Metavesco, Inc. (OTC: MVCO) operates as a diversified holding and operating platform that acquires and manages cash-flow businesses while building a long-term Bitcoin-powered digital asset treasury and supporting associated ecosystem offerings like OTCfi Nexus and related ventures.',
          url: 'https://metavesco.com/'
        },
        "Charlie's Holdings, Inc.": {
          description: 'Charlie’s Holdings, Inc. (OTCQB: CHUC) is a consumer products company that formulates, markets, and distributes non-combustible nicotine and alternative alkaloid vapor products under brands like Pacha and SBX through distributors, specialty retailers, and third-party online resellers in the U.S. and select international markets.',
          url: 'https://charliesholdings.com/'
        },
        'FullPac': {
          description: 'FullPAC, Inc., often referred to by its platform name GOTV (Get Out The Vote), is a technology company that provides nonpartisan communication solutions for political campaigns and nonprofits. The company operates as a "pure \'Picks and Shovels\' play on the growth in political spending" by offering a suite of data-driven tools to mobilize voters.',
          url: 'https://gotv.com/'
        },
        'Newton Golf Company': {
          description: 'Newton Golf Company (formerly Sacks Parente Golf) is a technology-focused golf equipment manufacturer creating high-performance shafts, putters, and accessories for all skill levels, emphasizing lighter, faster designs using advanced materials like carbon fiber for increased swing speed, distance, and control, sold through e-commerce, retailers, and distributors globally. ',
          url: 'https://newtongolfco.com/'
        },
        'Realbricks': {
          description: 'We started Realbricks to empower the individual investor. Real estate has historically been one of the best-performing investment assets and a core part of many of the most successful investor’s portfolios.',
          url: 'https://www.realbricks.com/'
        },
        '': {
          description: '',
          url: ''
        }
      },
      speakers: [
        {
          imgClass: 'miglino',
          name: 'Chris Miglino',
          title: '"Welcome Keynote"',
          position: 'President - DNA',
          time: '9:00 AM - 9:30 AM',
          location: 'Patio del Fauno'
        },
        {
          name: 'AXE Compute',
          title: 'Company Presentation',
          time: '9:30 AM - 10:00 AM',
          location: 'Patio del Fauno',
          class: 'grayblue presenter noheight'
        },
        {
          name: 'Chardan',
          title: 'Fireside Chat',
          time: '10:00 AM - 10:20 AM',
          location: 'Patio del Fauno',
          class: 'grayblue presenter noheight'
        },
        {
          imgClass: 'greg',
          name: 'Greg Nickolson',
          title: 'dTAO',
          position: 'CEO - Team Rizzo',
          time: '11:00 AM - 11:30 AM',
          location: 'Patio del Fauno'
        }
      ],
      cardData: {
      },
      activeCardInfo: null,
      errorMessage: null,
      isModalOpen: false,
      isMobile: false,
    }
  },
  mounted() {
    this.isMobile = window.innerWidth < 768;
    window.addEventListener('resize', this.handleResize);
    window.addEventListener('keydown', this.handleEscKey);
  },
  methods: {
    handleResize() {
      this.isMobile = window.innerWidth < 768;
    },
    handleEscKey(event) {
      if (event.key === 'Escape' && this.isModalOpen) {
        this.closeModal();
      }
    },
    handleModalBackdropClick(event) {
      if (event.target.classList.contains('modal')) {
        this.closeModal();
      }
    },
    openModal(identifier) {
      if (this.cardData[identifier]) {
        this.activeCardInfo = this.cardData[identifier];
        this.activeCompanyInfo = null;
        this.errorMessage = null;
        this.isModalOpen = true;
      } else if (this.companyData[identifier]) {
        this.activeCompanyInfo = {
          ...this.companyData[identifier],
          company: identifier,
        };
        this.activeCardInfo = null;
        this.errorMessage = null;
        this.isModalOpen = true;
      } else {
        console.error(`Currently no info has been found for "${identifier}".`);
        this.activeCardInfo = null;
        this.activeCompanyInfo = null;
        this.errorMessage = null;
        this.isModalOpen = false;
      }
    },
    closeModal() {
      this.isModalOpen = false;
      this.activeCardInfo = null;
      this.activeCompanyInfo = null;
      this.errorMessage = null;
    },
  },
  beforeUnmount() {
    window.removeEventListener('resize', this.handleResize);
    window.removeEventListener('keydown', this.handleEscKey);
  },
};
</script>
